<template>
  <div class="learning-quiz-box">
    <label :for="'question' + id">
            <input type="radio" :id="'question' + id" name="test wiedzy" :value="answer" v-model="selectedAnswer">
            <div class='circle-test'>
                <img src="images/statusPage/ty-success.png" alt="">
            </div>
            <div class="question">
                <p>{{name}}</p>
            </div>
    </label>
  </div>
</template>

<script>
export default {
    props:{
        id:{
            type: Number,
            required: true,
            default: 0
        },
        name:{
            type: String,
            required: true,
            default: ''
        },
        questionId:{
            type: Number,
            required: true,
            default:0
        }
    },
    computed:{
        answer(){
            return {questionId: this.questionId, answerId: this.id}
        },
        selectedAnswer:{
            get(){
                return this.$store.getters.getSelectedAnswer
            },
            set(value){
                this.$store.commit('setSelectedAnswer', value)
            }
        }
    }
}
</script>

<style scoped>
label{
    display: flex;
    border: 1px solid #d8d8d8;
    margin-bottom: 20px;
    cursor: pointer;
    padding: 20px 0px;
}
[type=radio] { 
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}


[type=radio] + .circle-test > img {
  cursor: pointer;
  visibility: hidden;
  opacity: 0;
  transition: 0.2s ease-in-out all;
}

/* CHECKED STYLES */
[type=radio]:checked + .circle-test > img {
  visibility: visible;
  opacity: 1;
}

.circle-test{
    margin-left: 10px;
    width: 20px;
    height: 20px;
    border: 1.5px solid #6e6e6e;
    border-radius: 50%;
    position: relative;
    margin-right: 10px;
}

.circle-test img{
    position: absolute;
    top: -2px;
    left: -2px;
    display: inline-block;
    width: 20px;
    height: 20px
}

.question{
    display: inline-block;
    width: calc(100% - 20px);
    padding-right: 10px;
}

p{
    margin-bottom: 0px;
}
</style>